/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Friends_Send_NoneInputs */

const en_friends_send_none = /** @type {(inputs: Friends_Send_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No friends yet – swap codes under`)
};

const de_friends_send_none = /** @type {(inputs: Friends_Send_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Freunde – Codes tauscht ihr unter`)
};

/**
* | output |
* | --- |
* | "No friends yet – swap codes under" |
*
* @param {Friends_Send_NoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const friends_send_none = /** @type {((inputs?: Friends_Send_NoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Friends_Send_NoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_friends_send_none(inputs)
	return en_friends_send_none(inputs)
});